<template>
  <div class="app_container user-check__info">
    <div class="header">
      用户核对
    </div>
    <div class="stat">
      <el-table :data="statData" border style="width: 70%" :header-cell-style="customHeaderStyle">
        <el-table-column v-for="(item, idx) in statColumns" :key="idx" :label="item.label" align="center">
          <template slot-scope="scope">
            <div >{{ scope.row[item.prop] || 0 }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="tab-content">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="基础信息修改" name="1">
          <PaneContent activeTab="1" :isLast="isLast"/>
        </el-tab-pane>
        <el-tab-pane label="人员新增" name="2" lazy>
          <PaneContent activeTab="2" :isLast="isLast"/>
        </el-tab-pane>
        <el-tab-pane label="其他" name="3" lazy>
          <PaneContent activeTab="3"/>
        </el-tab-pane>
        <el-tab-pane label="人员缺失" name="4" lazy>
          <PaneContent activeTab="4"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import PaneContent from './components/paneContent.vue';
import { getUserCheckInfo } from "@/api/user.js"
export default {
  name: "userCheckDetail",
  components: { PaneContent },
  data() {
    return {
      statColumns: [
        {
          label: "导入总数",
          prop: "userCheckNum",
        },
        {
          label: "基础信息修改",
          prop: "userUpdateNum",
        },
        {
          label: "人员新增",
          prop: "userAddNum",
        },
        {
          label: "其他",
          prop: "userOtherNum",
        },
        {
          label: "无更新",
          prop: "noUpdateNum",
        },
        {
          label: "人员缺失",
          prop: "userMissNum",
        },
      ],
      activeTab: "1",
      statData: [{}],
      isLast: false,
    };
  },
  created() {
    this.uuid = this.$route.query.id
    this.getInfo()
  },
  methods: {
    getInfo() { 
      getUserCheckInfo({uuid: this.uuid}).then(res => {
        if (res && res.code == 0) {
          this.statData = [res.data]
          this.isLast = res.data.isLast;
        }
      })
    },

    customHeaderStyle({ column }) {
      let headerStyle = {
        background: "#DCE7FA",
        color: "#343C4A",
        fontWeight: 500,
      };
      if (column.label === "人员缺失") {
        return { ...headerStyle, background: "#FDE6C8" };
      }
      return headerStyle
    },
  },
};
</script>
<style lang='scss' scoped>
.user-check__info {
  padding: 24px;

  .header {
    padding-bottom: 16px;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    border-bottom: 1px solid #ddd;
  }

  .stat {
    margin-top: 16px;
  }

  .tab-content {
    margin-top: 24px;
  }
}

/deep/ .el-tabs__item {
  font-size: 16px;
  color: #000;
}

/deep/ .el-tabs__item.is-active {
  font-size: 16px;
  color: #3a85ff;
}
</style>